import React from "react"
import { Checkbox } from "@chakra-ui/react"
import useGuestsStore from "services/useGuestsStore"

type Props = {
  allSelected: boolean
  onToggle: () => void
}

const SelectAllCheckbox = ({ allSelected, onToggle }: Props) => {
  const selectAllBlocked = useGuestsStore((s) => s.selectAllBlocked)

  return (
    <Checkbox
      p={2}
      aria-label="Select all guests"
      isChecked={allSelected}
      isDisabled={selectAllBlocked}
      onChange={(e) => {
        e.stopPropagation()
        onToggle()
      }}
    />
  )
}

export default SelectAllCheckbox
